"use client";

import { useState, useEffect } from "react";

const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState("sm");

  const handleResize = () => {
    const width = window.innerWidth;
    if (width < 576) {
      setBreakpoint("xs");
    } else if (width < 768) {
      setBreakpoint("sm");
    } else if (width < 992) {
      setBreakpoint("md");
    } else if (width < 1200) {
      setBreakpoint("lg");
    } else {
      setBreakpoint("xl");
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return breakpoint;
};

export default useBreakpoint;
